export const convertToCurrentTimeZone = (time) => {
    return window.moment(new Date((window.moment.utc(time).unix()) * 1000).toISOString()).format('YYYY-MM-DD HH:mm:ss');
}